"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var Game = /*#__PURE__*/ function() {
    function Game(initialState) {
        _class_call_check(this, Game);
        this.initialState = initialState || [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        this.state = this.initialState.map(function(row) {
            return _to_consumable_array(row);
        });
        this.score = 0;
        this.status = "idle";
    }
    _create_class(Game, [
        {
            key: "moveLeft",
            value: function moveLeft() {
                var _this = this, _loop = function(i) {
                    var row = _this.state[i];
                    var filtered = row.filter(function(cell) {
                        return cell !== 0;
                    });
                    var merged = [];
                    for(var j = 0; j < filtered.length; j++)if (filtered[j] === filtered[j + 1]) {
                        var mergedValue = filtered[j] * 2;
                        merged.push(mergedValue);
                        _this.score += mergedValue;
                        j++;
                    } else merged.push(filtered[j]);
                    var final = _to_consumable_array(merged);
                    while(final.length < 4)final.push(0);
                    _this.state[i] = final;
                };
                var previousState = this.getState();
                for(var i = 0; i < this.state.length; i++)_loop(i);
                if (this.hasStateChanged(previousState)) {
                    this.addRandomCell();
                    this.updateStatus();
                }
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var _this = this, _loop = function(i) {
                    var row = _this.state[i];
                    var filtered = row.filter(function(cell) {
                        return cell !== 0;
                    });
                    var merged = [];
                    for(var j = filtered.length - 1; j >= 0; j--)if (filtered[j] === filtered[j - 1]) {
                        var mergedValue = filtered[j] * 2;
                        merged.push(mergedValue);
                        _this.score += mergedValue;
                        j--;
                    } else merged.push(filtered[j]);
                    merged.reverse();
                    var final = _to_consumable_array(merged);
                    while(final.length < 4)final.unshift(0);
                    _this.state[i] = final;
                };
                var previousState = this.getState();
                for(var i = 0; i < this.state.length; i++)_loop(i);
                if (this.hasStateChanged(previousState)) {
                    this.addRandomCell();
                    this.updateStatus();
                }
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                var _this = this, _loop = function(j) {
                    var column = _this.state.map(function(row) {
                        return row[j];
                    });
                    var filtered = column.filter(function(cell) {
                        return cell !== 0;
                    });
                    var merged = [];
                    for(var k = 0; k < filtered.length; k++)if (filtered[k] === filtered[k + 1]) {
                        var mergedValue = filtered[k] * 2;
                        merged.push(mergedValue);
                        _this.score += mergedValue;
                        k++;
                    } else merged.push(filtered[k]);
                    var final = _to_consumable_array(merged);
                    while(final.length < 4)final.push(0);
                    for(var i = 0; i < 4; i++)_this.state[i][j] = final[i];
                };
                var previousState = this.getState();
                for(var j = 0; j < 4; j++)_loop(j);
                if (this.hasStateChanged(previousState)) {
                    this.addRandomCell();
                    this.updateStatus();
                }
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                var _this = this, _loop = function(j) {
                    var column = _this.state.map(function(row) {
                        return row[j];
                    });
                    var filtered = column.filter(function(cell) {
                        return cell !== 0;
                    });
                    var merged = [];
                    for(var k = filtered.length - 1; k >= 0; k--)if (filtered[k] === filtered[k - 1]) {
                        var mergedValue = filtered[k] * 2;
                        merged.push(mergedValue);
                        _this.score += mergedValue;
                        k--;
                    } else merged.push(filtered[k]);
                    merged.reverse();
                    var final = _to_consumable_array(merged);
                    while(final.length < 4)final.unshift(0);
                    for(var i = 0; i < 4; i++)_this.state[i][j] = final[i];
                };
                var previousState = this.getState();
                for(var j = 0; j < 4; j++)_loop(j);
                if (this.hasStateChanged(previousState)) {
                    this.addRandomCell();
                    this.updateStatus();
                }
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.state.map(function(row) {
                    return _to_consumable_array(row);
                });
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "start",
            value: function start() {
                this.status = "playing";
                this.addRandomCell();
                this.addRandomCell();
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.state = this.initialState.map(function(row) {
                    return _to_consumable_array(row);
                });
                this.score = 0;
                this.status = "idle";
            }
        },
        {
            key: "addRandomCell",
            value: function addRandomCell() {
                var emptyCells = [];
                for(var i = 0; i < this.state.length; i++){
                    for(var j = 0; j < this.state[i].length; j++)if (this.state[i][j] === 0) emptyCells.push([
                        i,
                        j
                    ]);
                }
                if (emptyCells.length > 0) {
                    var randomIndex = Math.floor(Math.random() * emptyCells.length);
                    var _emptyCells_randomIndex = _sliced_to_array(emptyCells[randomIndex], 2), row = _emptyCells_randomIndex[0], col = _emptyCells_randomIndex[1];
                    this.state[row][col] = 2;
                }
            }
        },
        {
            key: "checkWin",
            value: function checkWin() {
                for(var i = 0; i < this.state.length; i++)for(var j = 0; j < this.state[i].length; j++){
                    if (this.state[i][j] === 2048) return true;
                }
                return false;
            }
        },
        {
            key: "checkLose",
            value: function checkLose() {
                for(var i = 0; i < this.state.length; i++)for(var j = 0; j < this.state[i].length; j++){
                    if (this.state[i][j] === 0) return false;
                }
                for(var i1 = 0; i1 < this.state.length; i1++)for(var j1 = 0; j1 < this.state[i1].length - 1; j1++){
                    if (this.state[i1][j1] === this.state[i1][j1 + 1]) return false;
                }
                for(var i2 = 0; i2 < this.state.length - 1; i2++)for(var j2 = 0; j2 < this.state[i2].length; j2++){
                    if (this.state[i2][j2] === this.state[i2 + 1][j2]) return false;
                }
                return true;
            }
        },
        {
            key: "hasStateChanged",
            value: function hasStateChanged(previousState) {
                for(var i = 0; i < this.state.length; i++)for(var j = 0; j < this.state[i].length; j++){
                    if (this.state[i][j] !== previousState[i][j]) return true;
                }
                return false;
            }
        },
        {
            key: "updateStatus",
            value: function updateStatus() {
                if (this.checkWin()) this.status = "win";
                else if (this.checkLose()) this.status = "lose";
                else this.status = "playing";
            }
        }
    ]);
    return Game;
}();
window.Game = Game;
if (typeof module !== "undefined" && module.exports) module.exports = Game;

//# sourceMappingURL=index.9a5712b7.js.map
